module.exports = __webpack_public_path__ + "img/landing-general-info-screen-3.c7ea2029.png";